import { buildPartGroups, STAGES } from './cannabisLoaderGeometry';

const allGroups = buildPartGroups();
/** @type {Map<string, number>} */
const idToTh = new Map();
for (const st of STAGES) {
  if (st.k === 'halo') continue;
  const group = allGroups.find((g) => g.key === st.k);
  if (!group) continue;
  for (const p of group.paths) {
    idToTh.set(p.id, st.th);
  }
}

/**
 * @param {string} id
 * @param {number} progress
 */
export function isPathRevealed(id, progress) {
  const th = idToTh.get(id);
  if (th === undefined) return false;
  return progress >= th;
}

export function statusLabelForProgress(progress) {
  let label = 'initializing...';
  for (const st of STAGES) {
    if (progress >= st.th) {
      label = st.l;
    }
  }
  return label;
}

export function haloRevealed(progress) {
  const st = STAGES.find((s) => s.k === 'halo');
  return st ? progress >= st.th : false;
}
